import React from "react";
import { Button, Column, Icon, Row, Sheet, Text } from "@amzn/meridian";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";

type ObjectInstanceSuccessSheetProps = {
  open: boolean;
  objectType: string;
  isUploading: boolean;
  onInspectNext: () => void;
  onFinish: () => void;
};

const ObjectInstanceSuccessSheet = ({
  open,
  objectType,
  isUploading,
  onInspectNext,
  onFinish,
}: ObjectInstanceSuccessSheetProps) => {
  const displayName = objectType.charAt(0).toUpperCase() + objectType.slice(1);
  
  return (
    <Sheet
      className="object-instance-success-sheet"
      type="overlay"
      side="bottom"
      open={open}
      onClose={onFinish}
    >
      <div style={{ borderRadius: "21px" }}>
        <Column spacing="400">
          {isUploading ? (
            // Uploading state
            <Column spacing="300" alignmentHorizontal="center">
              <div style={{ 
                width: "40px", 
                height: "40px", 
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #FF9900",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }} />
              <Text type="h400">Uploading photo...</Text>
              <Text type="b100" color="secondary">
                Please wait
              </Text>
            </Column>
          ) : (
            // Success state
            <>
              <Row alignmentHorizontal="center">
                <Column spacing="200" alignmentHorizontal="center">
                  <Text type="h400">Photo Uploaded!</Text>
                  <Text type="b100" color="secondary">
                    AI analysis running in background
                  </Text>
                </Column>
              </Row>
              
              <Column spacing="300">
                <Button
                  size="large"
                  onClick={onInspectNext}
                  type="primary"
                >
                  Inspect Next {displayName}
                </Button>
                <Button
                  size="large"
                  onClick={onFinish}
                  type="tertiary"
                >
                  Finish {displayName} Inspection
                </Button>
              </Column>
            </>
          )}
        </Column>
      </div>
    </Sheet>
  );
};

export default ObjectInstanceSuccessSheet;
